import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { PaytableComponent, PaytableComponentConfig } from "../paytable/paytable-component";

export class PaytableFactory implements ComponentFactory {

    protected config: Partial<PaytableComponentConfig>;

    constructor(config?: Partial<PaytableComponentConfig>) {

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public build(): AbstractComponent {
        return new PaytableComponent(this.config);
    }
}
